module.exports = __webpack_public_path__ + "img/icon_twitter.f916948d.svg";